import * as React from 'react';
import { LinkedText } from './LinkedText';
import type { WhyUsZones } from '../../types/whyus-landing';

interface ZonesSectionProps {
  zones: WhyUsZones;
}

export function ZonesSection({ zones }: ZonesSectionProps) {
  return (
    <section className="whyus-zones">
      <style>{`
        .whyus-zones {
          padding: 72px 24px;
          background: #fff;
        }
        .whyus-zones-inner {
          max-width: 720px;
          margin: 0 auto;
        }
        .whyus-zones h2 {
          font-size: 28px;
          font-weight: 800;
          color: #1a1a1a;
          margin: 0 0 16px;
        }
        .whyus-zones p {
          font-size: 16px;
          color: #444;
          line-height: 1.7;
          margin: 0 0 14px;
        }
        .whyus-zone-list {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          margin: 0 0 16px;
          padding: 0;
          list-style: none;
        }
        .whyus-zone-list li {
          background: #f0fdf0;
          color: #176b1c;
          border-radius: 999px;
          padding: 6px 12px;
          font-size: 14px;
          font-weight: 600;
        }
        @media (max-width: 640px) {
          .whyus-zones h2 {
            font-size: 24px;
          }
        }
      `}</style>
      <div className="whyus-zones-inner">
        <h2>¿Llegamos a tu zona?</h2>
        {zones.names.length > 0 && (
          <ul className="whyus-zone-list">
            {zones.names.map((name) => (
              <li key={name}>{name}</li>
            ))}
          </ul>
        )}
        <p><LinkedText text={zones.sentence} /></p>
        <p><LinkedText text={zones.shipping_note} /></p>
      </div>
    </section>
  );
}
